
import * as OM from '@/model';
import { Prop } from 'vue-property-decorator';
import { StripeServices } from '@/services/StripeServices';
import { Options, Vue } from 'vue-class-component';
import { BaseUserClient, ShoppingCartClient, StripeClient } from '@/services/Services';
import store from '@/store';

@Options({})
export default class stripeCheckout extends Vue {

    @Prop() shoppingCart: OM.ShoppingCart;
    @Prop({
        required: true
    }) stripeKey: string;

    showMailInput: boolean = false;
    contactMail: string = "";

    stripe: any;
    paymentConfig: OM.StripeClientPaymentConfig = null;
    error: string = "";

    paymentUrl: string = "";

    get isTestMode(){
        return this.stripeKey.indexOf('pk_test') > -1
    }

    isValidMail(input: string){
        let regex = new RegExp(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g)
        return regex.test(input);
    }

    created(){
        this.contactMail = store.state.user.contactData.email;
        if(this.isValidMail(this.contactMail)){
            this.initStripe();
        } else {
            this.showMailInput = true;
        }
    }

    saveContactEmail(){
        BaseUserClient.saveContactEmail(store.state.user.identifier, this.contactMail)
        .then(x => {
            store.state.user.contactData.email = this.contactMail;
            this.showMailInput = false;
            this.initStripe();
        })
    }

    initStripe(){
        this.stripe = Stripe(this.stripeKey);
        if(window.cordova){
            this.paymentConfigCbStripe()
            .then(x => {
                this.paymentConfig = x;
            })
        } else {
            this.sessionCbStripe()
            .then(x => {
                this.paymentUrl = x;
            })
        }
    }

    sessionCbStripe(){
        return StripeClient.createSessionForCart(this.shoppingCart)
    }

    paymentConfigCbStripe(){
        return new Promise<OM.StripeClientPaymentConfig>((resolve, reject) => {
            ShoppingCartClient.save(this.shoppingCart)
            .then(x => {
                StripeClient.createClientPaymentConfigForCart(store.state.user.identifier)
                .then(x => resolve(x))
            })
        });
    }

    go(){
        if(window.cordova){
            StripeServices.makePayment(this.paymentConfig)
            .then(x => {
                if(x.code == '0')
                    this.$emit('complete', this.paymentConfig.paymentIntentId);
            })
            .catch(err => {
                console.log(err);
            })
        } else {
            this.$store.state.openBrowser(this.paymentUrl);
        }
    }

}

